/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Table, Empty, Popconfirm, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../constants'

import AddForm from './addForm'
import ViewDetails from './viewDetails'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedMedicalRecord: null,
			// complain_status: [],
			isViewDetailShown: false,
			selectedMedicalRecordUid: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// complain_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, user_uid, user_type } = AuthStore
		const isAdmin = _.isEqual(RoleCode.SUPERADMIN, user_type) || _.isEqual(RoleCode.SYSTEMADMIN, user_type)
		const isMedicalPersonnel = _.isEqual(RoleCode.MEDICALPERSONNEL, user_type)
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedMedicalRecord,
			isViewDetailShown, selectedMedicalRecordUid
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
							this.setState({ isAddFormShown: true, isEdit: false, selectedMedicalRecord: null })
						}} style={{ float: 'right' }}>New Record</button>
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
					</Row>
					<br />
					<Row>
						<Query 
							query={MEDICAL_RECORDS} 
							variables={{ searchFilter: filters, barangay_uid }}
							fetchPolicy='network-only'
						>
							{({ loading, error, data }) => {
								if (error) return <Empty/>

								let medicalRecords = _.has(data,'medicalRecords') ? data.medicalRecords.data : []
								medicalRecords = medicalRecords.map((medicalRecord, key) => Object.assign({}, medicalRecord, { key }))
								let _pagination = _.has(data, 'medicalRecords') ? data.medicalRecords.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [{
									title: 'Case Number',
									key: 'case_no',
									render: (record) => (
										<a 
											href='javascript:void(0)'
											onClick={() => {
												this.setState({ isViewDetailShown: true, selectedMedicalRecord: record })
											}}
										>
											{record.case_no}
										</a>
									)
								}, {
									title: 'Name',
									key: 'name',
									render: (record) => (
										<span>{`${record.first_name} ${record.middle_name} ${record.last_name}`}</span>
									)
								}, {
									title: 'Refer from',
									key: 'refer_from',
									dataIndex: 'refer_from'
								}, {
									title: 'Refer to',
									key: 'refer_to',
									dataIndex: 'refer_to'
								}, {
									title: 'Referral Date/Time',
									key: 'refer_date',
									render: (record) => {
										return (
											<span>{moment(record.refer_date).format('lll')}</span>
										)
									}
								}, {
									title: 'Action',
									key: 'action',
									width: 200,
									render: (record) => {
										const isOwner = _.isEqual(user_uid, record.created_by)
										return (
											<React.Fragment>
												<a 
													style={{ marginRight: 10 }}
													href='javascript:void(0)'
													onClick={() => {
														this.setState({ isViewDetailShown: true, selectedMedicalRecord: record })
													}}
												>
													View details
												</a>
												{
													(isAdmin || isOwner) &&
													<a href="#" style={{ marginRight: 10 }} onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedMedicalRecord: record })}>Edit</a>
												}
												{
													(isAdmin || isOwner) &&
													<Popconfirm
														title="Are you sure delete this medical record?"
														onConfirm={() => {
															const { deleteMedialRecord } = this.props
															deleteMedialRecord({ medical_record_uid: record.uid })
																.then((response) => {
																	message.success('Medical record successfully deleted.')

																	//create audit trail
																	const auditParams = {
																		module_name: 'Medical',
																		action: 'Delete',
																		message: `Deleted Medical record with case no ${record.case_no}`
																	}
																	AuthStore.saveAuditTrail(auditParams)
																}).catch(err => {
																	console.log('error deleting medical record', err)
																	message.error(err.message.replace('GraphQL error:', ''))
																})
														}}
														// onCancel={cancel}
														okText="Yes"
														cancelText="No"
													>
														<a href="javascript:void(0)" >Delete</a>
													</Popconfirm>
												}
											</React.Fragment>
										)
									}
								}]
								return (
									<Table 
										loading={loading}
										columns={columns} 
										dataSource={medicalRecords} 
										bordered
										onChange={this.handleOnChange}
										pagination={_pagination}
										scroll={{ x: 1020 }}
									/>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedMedicalRecord={selectedMedicalRecord}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedMedicalRecord: null })}
                        />
					}
					{
						isViewDetailShown &&
						<ViewDetails 
							file_url={selectedMedicalRecord.file_url}
							visible={isViewDetailShown}
							onCancel={() => this.setState({ isViewDetailShown: false, selectedMedicalRecord: null })}
						/>
					}
				</Col>
			</Row>
		)
	}
}

const MEDICAL_RECORDS = gql`
    query medicalRecords($barangay_uid: String, $searchFilter: SearchParams) {
		medicalRecords(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const DELETE_MEDICAL_RECORD = gql`
    mutation deleteMedicalRecord($input: JSON) {
		deleteMedicalRecord(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_MEDICAL_RECORD, {
		props({ mutate }) {
			return {
				deleteMedialRecord(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['medicalRecords']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
